import { COBURG } from "./propertyCoburg";
import { AINTREE } from "./propertyAintree";
import { DEMO_PROPERTIES } from "./demoProperties";
import { filterByVerification, normaliseProperty } from "./propertyModel";

// Verified real Alpha properties — always show in production.
export const VERIFIED_PROPERTIES = [COBURG, AINTREE];

// Full registry = verified + demonstration inventory. `filterByVerification`
// removes demo records automatically on the production hostname.
export const PROPERTIES = filterByVerification([
  ...VERIFIED_PROPERTIES,
  ...DEMO_PROPERTIES,
]);

export const PROPERTY_BY_SLUG = Object.fromEntries(PROPERTIES.map((p) => [p.slug, p]));

export const FEATURED_PROPERTY = COBURG; // hero highlight on homepage (verified only)

export function statusBadge(p) {
  const raw = p?.listing_status || p?.status;
  if (raw === "available") return { label: "Available now", tone: "green" };
  if (raw === "limited") return { label: "Limited vacancy", tone: "amber" };
  if (raw === "upcoming") return { label: "Coming soon", tone: "purple" };
  if (raw === "eoi") return { label: "Expressions of interest", tone: "purple" };
  if (raw === "paused") return { label: "Temporarily unavailable", tone: "neutral" };
  if (raw === "archived") return { label: "Archived", tone: "neutral" };
  return { label: "Filled", tone: "neutral" };
}

// Vacancy message — leads the card copy (Part 10 of the spec).
export function vacancyLabel(p) {
  const n = p?.vacancies ?? 0;
  const status = p?.listing_status || p?.status;
  if (status === "upcoming") return "Coming soon";
  if (status === "eoi") return "Expressions of interest";
  if (status === "paused") return "Temporarily unavailable";
  if (status === "filled") return "Fully occupied";
  if (status === "archived") return "Archived";
  if (n <= 0) return "No current vacancy";
  if (n === 1) return "1 vacancy available";
  return `${n} vacancies available`;
}

/** Normalise for consumption by the property card component. */
export function propertyView(p) {
  return normaliseProperty(p);
}
